import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';

const Home = () => {

  const areas = [
    {
      category: "Mental Health",
      topics: [
        "Anxiety Disorders",
        "Depression",
        "Highly Sensitive Person (HSP)",
        "Obsessive-Compulsive Disorder (OCD)",
        "Post-Traumatic Stress Disorder (PTSD)"
      ]
    },
    {
      category: "Life Challenges",
      topics: [
        "Grief and Loss",
        "Relationship Issues",
        "Family Dynamics",
        "Life Transitions",
        "Academic or Job Stress"
      ]
    },
    {
      category: "Trauma",
      topics: [
        "Post-Traumatic Stress Disorder (PTSD)",
        "Complex Trauma",
        "Childhood Trauma",
        "Trauma-Informed Care",
        "Religious or Spiritual Trauma"
      ]
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-image-section">
            <img 
              src="/images/aliciaProfile.jpg" 
              alt="Alicia Gostylo Counseling - Peaceful and welcoming environment" 
              className="hero-image"
            />
          </div>
          <div className="hero-content-section">
            <div className="hero-content">
              <div className="hero-logo">
                <img src="/images/logo.png" alt="Alicia Gostylo Counseling Logo" className="hero-logo-image" />
              </div>
              <h1>Welcome to Alicia Gostylo Counseling</h1>
              <p>Providing compassionate, professional counseling services to support your mental health and wellness journey in the state of Texas.</p>
              <Link to="/contact" className="cta-button">Begin Your Journey</Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Alicia */}
      <section className="about-section">
        <div className="about-content">
          <div className="about-text">
            <h2>About Alicia</h2>
            <p>
              I am a licensed professional counselor in Texas, specializing in attachment-based therapy 
              and trauma-informed care. My approach integrates evidence-based techniques with a deep 
              understanding of how early experiences shape our relationships and emotional patterns.
            </p>
            <p>
              I believe in creating a safe, non-judgmental space where you can explore your thoughts, 
              feelings, and experiences. Together, we'll work to identify patterns, develop new perspectives, 
              and create practical strategies for lasting change.
            </p>
            <Link to="/meet-alicia" className="learn-more-button">Learn More About Me</Link>
          </div>
          <div className="about-cards">
            <div className="about-card">
              <div className="about-card-icon">💙</div>
              <h3>Compassionate Care</h3>
              <p>Providing warm, empathetic support in a judgment-free environment where you feel truly heard and understood.</p>
            </div>
            <div className="about-card">
              <div className="about-card-icon">🎓</div>
              <h3>Professional Expertise</h3>
              <p>Licensed professional counselor with specialized training in attachment theory, trauma-informed care, and evidence-based therapeutic approaches.</p>
            </div>
            <div className="about-card">
              <div className="about-card-icon">🛡️</div>
              <h3>Safe Environment</h3>
              <p>Creating a secure, confidential space where you can explore difficult emotions and experiences without fear of judgment.</p>
            </div>
            <div className="about-card">
              <div className="about-card-icon">🔬</div>
              <h3>Evidence-Based Approach</h3>
              <p>Utilizing research-backed therapeutic techniques and interventions that have been proven effective for lasting change and healing.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Focus Areas */}
      <section className="specialized-areas-section">
        <h2>Specialized Focus Areas</h2>
        <p>
          I have developed particular expertise in these three areas, which require specialized 
          approaches and understanding. Click on each area to learn more about my specific 
          methods and experience.
        </p>
        <div className="specialized-areas-grid">
          <Link to="/areas-of-focus/grief" className="specialized-area-card">
            <div className="specialized-area-icon">💔</div>
            <h3>Grief</h3>
            <p>Supporting you through loss and helping you find meaning and healing in your grief journey</p>
            <span className="learn-more">Learn More →</span>
          </Link>
          <Link to="/areas-of-focus/dreams" className="specialized-area-card">
            <div className="specialized-area-icon">✨</div>
            <h3>Dreams</h3>
            <p>Exploring the unconscious mind through dream work for deeper self-understanding and healing</p>
            <span className="learn-more">Learn More →</span>
          </Link>
          <Link to="/areas-of-focus/spiritual-integration" className="specialized-area-card">
            <div className="specialized-area-icon">🕊️</div>
            <h3>Spiritual Integration</h3>
            <p>Integrating spirituality with therapeutic work, including attachment theory and spiritual relationships</p>
            <span className="learn-more">Learn More →</span>
          </Link>
        </div>

        <div className="areas-grid">
          {areas.map((area, index) => (
            <div key={index} className="area-card">
              <h2>{area.category}</h2>
              <ul>
                {area.topics.map((topic, topicIndex) => (
                  <li key={topicIndex}>{topic}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <div className="cta-section">
        <h2>Ready to Begin Your Healing Journey?</h2>
        <p>
          Take the first step towards emotional well-being and personal growth. 
          I'm here to support you every step of the way.
        </p>
        <Link to="/contact" className="cta-button">Get Started Today</Link>
      </div>

      <div className="good-faith-estimate">
        <h3>GOOD FAITH ESTIMATE NOTICE</h3>
        <p>
          You have the right to receive a 'Good Faith Estimate' explaining how much your therapy may cost. 
          Under the law, health care providers need to give patients who do not have insurance, or who are 
          not using insurance, a cost estimate of the bill for medical items and services.
        </p>
      </div>
      <div className="good-faith-estimate">
        <h3>LEGAL NOTICES</h3>
        <div className="legal-notices-content">
          <p>
          Client has the right to: 
          </p>
          <ul>
            <li>Request the consumer's health care records from the licensee.</li>
            <li>Contact the Council, as found on the Council's <a href="https://bhec.texas.gov/contact-us/">Contact Us web page</a>.</li>
            <li>File a consumer complaint with the <a href="https://texasattorneygeneral.gov/consumer-protection">Office of Attorney General's Consumer Protection webpage</a>.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
